import { SnackbarProvider } from 'notistack'
import { Outlet } from 'react-router-dom'

import { InventoryBrowserContext, useBinContextProvider } from './inventoryBrowserContext'

export const InventoryBrowser = () => {
  return (
    <SnackbarProvider>
      <InventoryBrowserContext.Provider value={useBinContextProvider()}>
        <Outlet />
      </InventoryBrowserContext.Provider>
    </SnackbarProvider>
  )
}
